// src/components/shared/StatCard.js
// Card de KPI individual usado em PageInfoStrip (2026-05-11, Fase 10).
//
// API:
//   label      — overline acima do valor (uppercase, 11px)
//   value      — número/string grande (24px, 700)
//   total      — opcional; "23/45" formato
//   sub        — texto pequeno abaixo (11px, tone color)
//   tone       — 'default' | 'primary' | 'success' | 'warning' | 'error'
//                (afeta cor do value E do sub)
//   icon       — opcional, ReactNode

import React from 'react'
import { Card, Box, Typography } from '@mui/material'

const TONE_COLOR = {
  default: 'text.primary',
  primary: 'primary.main',
  success: 'success.main',
  warning: 'warning.main',
  error:   'error.main',
}

export default function StatCard({ label, value, total, sub, tone = 'default', icon }) {
  const color = TONE_COLOR[tone] || TONE_COLOR.default
  return (
    <Card
      variant="outlined"
      sx={{
        flex: 1,
        minWidth: 140,
        maxWidth: 280,
        p: 1.5,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {icon && <Box sx={{ color: 'text.secondary', display: 'flex' }}>{icon}</Box>}
        <Typography
          variant="overline"
          sx={{ color: 'text.secondary', lineHeight: 1, m: 0 }}
        >
          {label}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5 }}>
        <Typography
          component="span"
          sx={{
            fontSize: '1.5rem',
            fontWeight: 700,
            color,
            lineHeight: 1.1,
            fontFamily: '"IBM Plex Sans", Roboto, sans-serif',
          }}
        >
          {value}
        </Typography>
        {total != null && (
          <Typography
            component="span"
            sx={{
              fontSize: '0.875rem',
              color: 'text.secondary',
              fontWeight: 400,
            }}
          >
            /{total}
          </Typography>
        )}
      </Box>
      {sub && (
        <Typography
          variant="caption"
          sx={{ color, mt: 0.25, lineHeight: 1.3 }}
        >
          {sub}
        </Typography>
      )}
    </Card>
  )
}
